export default "__VITE_ASSET__fa6094ed__"